import { supabase } from '../lib/supabase';

export const getAffiliateUrl = (firmId: string): string => {
  return `/go/${firmId}`;
};

export async function getAffiliateRedirectUrl(firmId: string): Promise<string | null> {
  try {
    const { data, error } = await supabase
      .from('affiliate_links')
      .select('redirect_url')
      .eq('prop_name', firmId)
      .single();

    if (error || !data) {
      console.error('Error fetching affiliate link:', error);
      return null;
    }

    return data.redirect_url;
  } catch (error) {
    console.error('Error:', error);
    return null;
  }
}